import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';
import { pathPermitido, primeiraRotaPermitida } from '../config/menus';

/**
 * Permissões do perfil logado (Administrativo → Perfis de Usuário).
 * Carrega uma vez por sessão/troca de token; consumido pelo Sidebar (montar o
 * menu), pelo TabWatcher (bloquear URL digitada) e pela guarda do PDV.
 * Falha na API = libera tudo no visual — o backend continua barrando com 403.
 */
const PermissoesContext = createContext(null);

const TUDO = { admin: true, menus: ['*'], submenus: ['*'] };

export function PermissoesProvider({ children }) {
  const { token } = useAuth();
  const [perms, setPerms]   = useState(null);
  const [pronto, setPronto] = useState(false);

  useEffect(() => {
    if (!token) { setPerms(null); setPronto(false); return; }
    let ativo = true;
    setPronto(false);
    api.get('/perfis/minhas-permissoes')
      .then(r => { if (ativo) setPerms(r.data); })
      .catch(() => { if (ativo) setPerms(TUDO); })
      .finally(() => { if (ativo) setPronto(true); });
    return () => { ativo = false; };
  }, [token]);

  const permitido = useCallback(path => pathPermitido(perms, path), [perms]);
  const rotaInicial = useCallback(() => primeiraRotaPermitida(perms), [perms]);

  return (
    <PermissoesContext.Provider value={{ perms, pronto, permitido, rotaInicial }}>
      {children}
    </PermissoesContext.Provider>
  );
}

export function usePermissoes() {
  return useContext(PermissoesContext) || { perms: TUDO, pronto: true, permitido: () => true, rotaInicial: () => '/dashboard' };
}
